<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 22 22"
    fill="none"
    :stroke="iconStroke"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 21V11.3981C6 10.3299 6 9.79579 6.24458 9.34781C6.48915 8.89983 6.93842 8.61101 7.83697 8.03338L9.91849 6.69526C10.4437 6.35763 10.7063 6.18881 11 6.18881C11.2937 6.18881 11.5563 6.35763 12.0815 6.69526L14.163 8.03338C15.0616 8.61101 15.5108 8.89983 15.7554 9.34781C16 9.79579 16 10.3299 16 11.3981V21"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M11 12H11.009" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M20 21V15.1623C20 12.8707 18.7408 12.6852 16 12"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 21V15.1623C2 12.8707 3.25916 12.6852 6 12"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M1 21H21" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M11 21V17" stroke-width="1.5" stroke-linecap="round" />
    <path
      d="M11 6V3.98221M11 3.98221V1.97035C11 1.49615 11 1.25905 11.1464 1.11173C11.6061 0.649394 13.5 1.74303 14.2203 2.18653C14.8285 2.56105 15 3.30914 15 3.98221H11Z"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '22',
    },
    width: {
      type: String,
      default: '22',
    },
    color: {
      type: String,
      default: 'primary-gray-700',
    },
  },
  computed: {
    /**
     * Icon Style
     * @param {void}
     * @returns {string} - Color
     * @description Assigns the specific color to the icon
     */
    iconStroke() {
      return `var(--${this.color})`
    },
  },
}
</script>
